




































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import FileUpload from "vue-upload-component";
import Upload from "@/store/upload";

@Component({
  components: {
    FileUpload
  }
})
export default class AppFileUpload extends Vue {
  @Prop() label: string;
  @Prop() name: string;
  @Prop() placeholder: string;
  @Prop({ default: "text" }) type: string;
  @Prop() disabled: boolean;
  @Prop() value: string;

  files: any[] = [];

  @Emit("input")
  update(e: any) {
    return this.files.map(item => {
      return {
        file_id: item.file_id || item.id,
        file_name: item.name
      };
    });
  }

  async inputFile(newFile: any, oldFile: any) {
    if (newFile && !oldFile && newFile.file) {
      try {
        newFile.active = true;
        const res = await Upload.upload(newFile.file);
        newFile.active = false;
        newFile.success = true;
        newFile.id = res.response.data.id;
        newFile.file_id = res.response.data.id;
        setTimeout(() => {
          this.$emit(
            "input",
            this.files.map(item => {
              return {
                file_id: newFile.id,
                file_name: item.name
              };
            })
          );
        });
      } catch (error) {
        newFile.active = false;
        newFile.error = true;
      }
    }
  }

  @Emit("onEditable")
  onEditable() {}

  async inputFilter(newFile: any, oldFile: any, prevent: any) {
    if (newFile && !oldFile) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
        return prevent();
      }
      if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
        return prevent();
      }
    }
  }

  async onRemove(file: any) {
    (this.$refs.upload as any).remove(file);
  }

  @Watch("value", { immediate: true, deep: true })
  valueChange(data: any, oldData: any) {
    data = data || [];
    this.files =
      data.map((item: any) => {
        return {
          ...item,
          active: false,
          progress: "0.00"
        };
      }) || [];
  }
}
